// Imports
import React from "react"
import ScrollContainer from "react-indiana-drag-scroll"
import { useSectionNewsData } from "@queries"
import { NewsCard } from "@molecules"
import { Section } from "@layout"

export const News = ({ strictTitle }) => {
  const { nodes } = useSectionNewsData();
  const link = {
    text: "Tovább",
    link: "/",
  }

  // sort nodes by published date
  const sortedNodes = nodes.sort((a, b) => {
    return new Date(b.published) - new Date(a.published)
  })

  return (
    <Section name="news">
      <div className="news-container">
        <h1> {!strictTitle ? "Esettanulmányok" : strictTitle} </h1>
        <ScrollContainer>
          <div className="news-cards">
            {sortedNodes.map((card, index) => {
              return (
                <NewsCard
                  key={index}
                  title={card.title}
                  date={card.published}
                  image={card.banner}
                  link={link}
                />
              )
            })}
          </div>
        </ScrollContainer>
      </div>
    </Section>
  )
}
